export default "__VITE_ASSET__1e57c078__"